"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _querystring = _interopRequireDefault(require("querystring"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HashManager =
/*#__PURE__*/
function () {
  function HashManager() {
    _classCallCheck(this, HashManager);
  }

  _createClass(HashManager, null, [{
    key: "parse",
    value: function parse() {
      var hashObject = _querystring["default"].parse(location.hash.substr(1));

      _.keys(hashObject).forEach(function (key) {
        hashObject[key] = _.flatten([hashObject[key] || []]);
      });

      return hashObject;
    }
  }, {
    key: "update",
    value: function update(object) {
      var newHash = _querystring["default"].stringify(object);

      if (newHash !== '&') {
        location.hash = newHash;
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var response = this.parse();

      if (_.isString(key)) {
        return response[key];
      }

      return response;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var hash = this.parse();
      hash[key] = _.flatten([value]);
      this.update(hash);
    }
  }, {
    key: "push",
    value: function push(key, value) {
      var hash = this.parse();
      hash[key] = hash[key] || [];
      hash[key].push(value);
      this.update(hash);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var hash = this.parse();
      hash[key] && delete hash[key];
      this.update(hash);
    }
  }]);

  return HashManager;
}();

exports["default"] = HashManager;